<template lang='pug'>
  v-flex(:class="classObj", :title='this.id')
    u-date-picker(v-model="data", :label='label', :disabled="component.disabled" prefix=" ", inner-style="ma-0 pa-0", :resultDate="true", hide-details)
</template> 

<script>
import UDatePicker from '@/components/util/DatePicker'

export default {
  name: 'u-date',

  components: {
    UDatePicker
  },

  props: {
    id: {
      type: String
    },
    component: {
      type: Object,
      required: true
    },
    resultForm: {
      type: Object
    },
    value: {}
  },

  watch: {
    value: {
      handler: function (val) {
        this.data = val
        this.triggerCalcs()
      },
      deep: true
    },
    data (val) {
      if (val && this.value && this.value.toString() === val.toString()) return
      this.$emit('input', val)
      this.triggerCalcs()
      this.onChange(val)
    }
  },

  computed: {
    label () {
      return this.t(this.id + '.label', this.component.label)
    }
  },

  data () {
    return {
      data: null
    }
  },

  methods: {
    triggerCalcs () {
      // eslint-disable-next-line no-new
      let e = new CustomEvent('calcs', { detail: { id: this.id } })
      document.dispatchEvent(e)
    }
  }
}
</script>

<style lang='stylus' scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/inputs/Date.vue